"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var FormComponentUtils_1 = require("./common/FormComponentUtils");
var HookUtils_1 = require("../../common/HookUtils");
var IDUtils_1 = require("../../utils/IDUtils");
var ValidationMessage_1 = __importDefault(require("../forms/common/ValidationMessage"));
var FieldValidationState_1 = require("./common/FieldValidationState");
var common_1 = require("../common");
var getChildren = function (children, currentSelection, onChange, setCurrentSelection, name) {
    return react_1.default.Children.map(children, function (radio) {
        return react_1.default.cloneElement(radio, {
            name: name,
            checked: currentSelection === radio.props.value,
            onChange: function (evt) {
                FormComponentUtils_1.handleInputValueChange(evt, setCurrentSelection, onChange);
            }
        });
    });
};
var RadioGroup = function (props) {
    var classes = props.classes, children = props.children, groupName = props.groupName, onChange = props.onChange, selectedValue = props.selectedValue, title = props.title, validationMessage = props.validationMessage, validationState = props.validationState, visuallyHiddenLabel = props.visuallyHiddenLabel, otherPrps = __rest(props, ["classes", "children", "groupName", "onChange", "selectedValue", "title", "validationMessage", "validationState", "visuallyHiddenLabel"]);
    var _a = HookUtils_1.useStateWithSingleProp(selectedValue), currentSelection = _a[0], setCurrentSelection = _a[1];
    var name = groupName ? groupName : IDUtils_1.generateRandomId();
    var fieldsetClasses = classnames_1.default('fds-switch-group', {
        invalid: validationState === FieldValidationState_1.FieldValidationState.INVALID,
        valid: validationState === FieldValidationState_1.FieldValidationState.VALID,
        'visually-hidden-label': visuallyHiddenLabel
    }, classes);
    return (react_1.default.createElement("fieldset", __assign({}, otherPrps, { className: fieldsetClasses }),
        title && (react_1.default.createElement("legend", null, visuallyHiddenLabel ? react_1.default.createElement(common_1.VisuallyHidden, null, title) : title)),
        getChildren(children, currentSelection, onChange, setCurrentSelection, name),
        react_1.default.createElement(ValidationMessage_1.default, { validationMessage: validationMessage, validationState: validationState })));
};
RadioGroup.defaultProps = {
    title: ''
};
exports.default = RadioGroup;
